import product from "../product.json" with { type: "json" };

/**
 * How the product names itself to a user, in one place.
 *
 * "Haven" is the internal name and stays in package names, the database, the
 * deployment stack and the ECR repositories — none of which a user sees. What a
 * user sees comes from `product.json`, so replacing it is one edit rather than a
 * hunt through templates and locale strings.
 *
 * It is JSON rather than TypeScript because the static shell needs the same
 * values at build time and cannot import a module: `index.html` loads before the
 * bundle, the web manifest is metadata, and the maintenance page is served
 * precisely when the bundle is not running. `build/generate-product-assets.mjs`
 * reads the same file.
 */

/** The product, as prose refers to it. */
export const PRODUCT_NAME: string = product.name;

/** Attribution form, for a page title. */
export const PRODUCT_TITLE = `${product.name} by ${product.attribution}`;

/** Who makes the product, for attribution beside its name. */
export const PRODUCT_ATTRIBUTION: string = product.attribution;

/**
 * Home-screen label. Deliberately short: a launcher truncates at roughly a
 * dozen characters, and a truncated name reads worse than a general one.
 */
export const PRODUCT_SHORT_NAME: string = product.shortName;

/** What the product is for, where a name alone does not say. */
export const PRODUCT_STRAPLINE: string = product.strapline;
